import { ShowLoginModalState } from "Application/models";
import { create } from "zustand";

export const useShowLoginModalStore = create<ShowLoginModalState>((set) => ({
  isModalOpen: false,
  setIsModalOpen: (isLoginModalOpen: boolean) => set({ isModalOpen: isLoginModalOpen })
}));